import React from "react";

const links = [
	{
		href: "/s/chicago-dating",
		name: "Chicago Dating",
	},
	{
		href: "/s/washington-dating",
		name: "Washington Dating",
	},
	{
		href: "/s/seattle-dating",
		name: "Seattle Dating",
	},
	{
		href: "/s/los-angeles-dating",
		name: "Los Angeles Dating",
	},
	{
		href: "/s/philadelphia-dating",
		name: "Philadelphia Dating",
	},
	{
		href: "/s/atlanta-dating",
		name: "Atlanta Dating",
	},
	{
		href: "/s/nyc-dating",
		name: "NYC Dating",
	},
	{
		href: "/s/christian-singles",
		name: "Christian Singles",
	},
	{
		href: "/s/jewish-singles",
		name: "Jewish Singles",
	},
	{
		href: "/s/spiritual-singles",
		name: "Spiritual Singles",
	},
	{
		href: "/s/muslim-dating",
		name: "Muslim Dating",
	},
	{
		href: "/s/gay-dating",
		name: "Gay Dating",
	},
	{
		href: "/s/bisexual-dating",
		name: "Bisexual Dating",
	},
	{
		href: "/s/lesbian-dating",
		name: "Lesbian Dating",
	},
	{
		href: "/s/liberal-dating-sites",
		name: "Liberal Dating",
	},
	{
		href: "/s/vegan-dating",
		name: "Vegan Dating",
	},
	{
		href: "/s/vegetarian-dating",
		name: "Vegetarian Dating",
	},
	{
		href: "/s/conservative-dating-sites",
		name: "Conservative Dating",
	},
];

const SeoLink = () => {
	const link = links[Math.floor(Math.random() * links.length)];

	return (
		<a
			className="footer-section-link"
			href={link.href}
		>
			{link.name}
		</a>
	);
};

export default SeoLink;



// WEBPACK FOOTER //
// ./src/shared/components/Footer/SeoLink.jsx